import * as jsxRuntime from "/home/ubuntu/bookmd/client/apps/prior-auth-v2/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment